
const prod = {
    url: {
        STU_URL: 'https://api.kapuwelfare.apcfss.in/apkwdc/',//PROD
        FILE_DOWNLOAD_URL: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/",
        FILE_UPLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-upload/bucket/affiliation-documents/affiliation/',

    }
};
const protocol = window.location.protocol === "https:" ? "https" : "http";
const dev = {
    url: {

        STU_URL: 'https://swapi2.dev.nidhi.apcfss.in/apkwdc/', //DEV
        FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,


    }
};

const local = {
    url: {
        // STU_URL: "http://172.16.119.243:8008/apkwdc/",  //NOSONAR
        STU_URL: 'https://swapi2.dev.nidhi.apcfss.in/apkwdc/',
        FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
        FILE_DOWNLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/`,

    }

};


export const config = process.env.NODE_ENV === 'development' ? dev : prod;